module.exports = __webpack_public_path__ + "img/konto-active.505b61bc.svg";